module.exports = __webpack_public_path__ + "img/content3.2b1b83b2.png";